<template>
  <div class="policy" :class="[
    !pendencyLoading
      ? (this.reversedReplies[0] && this.reversedReplies[0].status
        ? `pendency--status--${this.reversedReplies[0].status.id}`
        : `pendency--status--${this.status.id}`)
      : null,
    { 'policy--expanded': showMoreDetails },
  ]">

    <Loading v-if="pendencyLoading" />
    <template v-else>
      <div class="row row--policy box box--default" :class="{ 'row--active': showMoreDetails }">
        <div class="row__data row__data--medium row__data--fixed"
          :class="{ 'row__data--underline': $checkRolePermission('pendency_edit') }">
          <span v-if="$checkRolePermission('pendency_edit')" @click="showStatusPopup = true" style="cursor: pointer">
            <transition name="fade" mode="in-out">
              <PopupEditer v-if="showStatusPopup" @togglePopup="showStatusPopup = $event" :items="statuses"
                :selected="pendencyStatus" :label="'name'" @submit="updatePendencyStatus($event)" />
            </transition>
            {{ status.name_de }}
          </span>

          <span v-else>
            {{ status.name_de }}
          </span>
        </div>

        <div class="row__data row__data--large row__data ">
          <p v-if="this.policy && this.policy.policy_number !== null">
            {{ this.policy.policy_number }}
          </p>
          <p v-else>
            ----
          </p>
        </div>

        <div class="row__data row__data--large row__data ">
          <p v-if="this.policy">{{ formatDate(this.policy.created_at) }}</p>
        </div>


        <div class="row__data row__data--large policy__company">

          <p>{{ company }}</p>
        </div>
        <div class="row__data row__data--large">
          {{ branch }}
        </div>
        <!-- <div  
          class="row__data row__data--medium"
          :class="{ 'row__data--underline': $checkRolePermission('pendency_edit') }"
          >
          <span v-if="$checkRolePermission('pendency_edit')" @click="showAgentPopup = true" style="cursor: pointer">
            <transition name="fade" mode="in-out">
              <PopupEditer v-if="showAgentPopup" @togglePopup="showAgentPopup = $event" :items="agent" :selected="agent"
                :position="'left'" :label="['first_name', 'last_name']" @submit="updatePolicyAgent($event)" />
            </transition>
            {{ agent }}
          </span>

          <span v-else>
            {{ agent }}
          </span>
        </div>  -->

        <div 
          class="row__data row__data--medium"
          :class="{ 'row__data--underline': $checkRolePermission('pendency_edit') }"
        >
          <span
            v-if="$checkRolePermission('pendency_edit')"
            @click="showAgentPopup = true"
            style="cursor: pointer"
          >
            <transition name="fade" mode="in-out">
              <PopupEditer
                v-if="showAgentPopup"
                @togglePopup="showAgentPopup = $event"
                :items="policy.agent"
                :selected="policy.agent"
                :position="'left'"
                :label="['first_name', 'last_name']"
                @submit="updatePolicyAgent($event)"
              />
            </transition>

            {{ agent }}
          </span>

          <span v-else>
            {{ agent }}
          </span>
        </div> 


        <div class="row__data row__data--medium row__data--half row__data--last">
          <div v-if="pendency.files.length" class="row__data row__data--small row__data--pdf icon__pdf--active"
            @click="openPendencyFilesModal()">
          </div>
          <div v-else class="row__data row__data--small row__data--pdf icon icon__pdf"
            @click="openPendencyFilesModal()"></div>

          <div class="row__data row__data--small row__data--more" :class="{ 'row__data--rotate': showMoreDetails }"
            @click="showMoreDetails = !showMoreDetails">
          </div>
        </div>
      </div>
      <div class="policy__services" :class="{ 'policy__services--expand': showMoreDetails }">

        <div class="services" ref="services" :style="showMoreDetails
          ? { maxHeight: `${manualHeight}px` }
          : { maxHeight: 0 }
          " :class="{ 'services--expand': showMoreDetails }">
          <div class="services__no-data" v-if="!pendency">
            No services found
          </div>
          <template v-else>
            <div class="table__header table__header--inner">
              <div class="table__label table__label sender-label">
                Sender
              </div>

              <div class="table__label table__label beschreibung-label">
                Beschreibung
              </div>

              <div class="table__label table__label deadline-reciever-label medium-label">
                Deadline / Reciever
              </div>

              <div class="table__label table__label status-label medium-label">
                Status
              </div>

              <div class="table__label table__label tools-label ">Tools</div>

              <div class="table__label table__label dropdown-label"></div>
            </div>

            <PendencyService :service="pendency" :replies="pendency.replies" :policy="pendency.policy"
              :agent="pendency.agent" :created="pendency.created_at" :description="pendency.description"
              :deadline="pendency.deadline" :receiver="pendency.customer" :status="pendency.status"
              @toggle-replies="recalculateHeight" />
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import statics from "@/statics";
import PendencyService from "@/components/AccountDetails/PendencyService";
import PopupEditer from "@/partials/PopupEditer";
import Loading from "@/partials/Loading";
// import { formatDisplayDate } from "@/helpers/dateFormatters";
// import { fetchGlobalCustomer } from "@/helpers/accountDetailHelpers";
export default {
  name: "Pendency",

  components: {
    PendencyService,
    PopupEditer,
    Loading,
  },

  props: {
    pendency: {
      required: true,
      type: Object,
    },
    statuses: {
      required: true,
      type: Array
    },
    expandedPendencyId: {
      type: Number,
      required: false,
    }
  },

  data() {
    return {
      showMoreDetails: false,
      showStatusPopup: false,
      showAgentPopup: false,
      pendencyLoading: false,
      manualHeight: 0,
    };
  },

  computed: {

    reversedReplies() {
      return [...this.pendency.replies].reverse();
    },

    company() {
      return this.policy
        ? this.policy.company.full_name || statics.empty
        : statics.empty;
    },

    branch() {
      if (this.policy && this.policy.policy_services.length) {
        return this.policy.policy_services[0].service.branch_category.name || statics.empty;
      }
      return null;
    },

    agent() {
      return this.pendency
        ? `${this.pendency.agent.first_name || statics.empty} ${this.pendency.agent
          .last_name || statics.empty}`
        : statics.empty;
    },

    services() {
      return this.pendency.pendencyService.length
        ? this.pendency.pendencyService
        : [];
    },

    servicesHeight() {
      if (this.$refs.services) {
        return [...this.$refs.services.children].reduce(
          (acc, child) => acc + child.clientHeight,
          0
        );
      } else {
        return null;
      }
    },


    
    policy() {
      return this.pendency.policy
    },

    status() {
      return this.pendency.status
    },

    pendencyStatus() {
      return this.pendency.status
        ? this.pendency.status.name
        : statics.empty;
    },
    pendencyStatusColor() {
      return this.policy ?
        statics.policyStatuses[
          statics.policyStatuses.findIndex(
            (status) => this.policy.company.status === status.id
          )
        ].name
        : null;
    },

    //   pendencyStatusColor() {
    //   if (!this.status || !this.status.id) return null;

    //   const colorMap = {
    //     1: '#ff3333',
    //     2: '#FF9E0F',
    //     3: '#22db8e'
    //   };

    //   return colorMap[this.status.id] || null;
    // }
  },
  watch: {
    servicesHeight(newValue) {
      this.servicesHeight = newValue;
    },
  },


  mounted() {  
    this.manualHeight = [...this.$refs.services.children].reduce(
      (acc, child) => acc + child.clientHeight,
      0
    );

    if (this.pendency.id == this.expandedPendencyId) {
      this.showMoreDetails = true;
    }
  },

  methods: {
    recalculateHeight() {
      this.$nextTick(() => {
        const height = this.$refs.services.scrollHeight;
        this.manualHeight = height;
      });
    },
    async updatePendencyStatus(pendencyStatusId) {
      this.pendencyLoading = true;
      const pendency = await this.$store.dispatch("updatePendencyStatus", {
        pendencyId: this.pendency.id,
        pendencyStatusId,
      });
      this.pendency = pendency;

      this.showStatusPopup = false;
      this.pendencyLoading = false;
    },
    formatDate(dateString) {
      if (!dateString) return '';

      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    },

    openPendencyFilesModal() {
      this.$store.commit("setShowFilesEditModal", true);
      this.$store.commit("setFilesToEditId", this.pendency.id);
      this.$store.commit("setFilesToEdit", this.pendency.files);
      this.$store.commit("setFilesEditMode", 'Pendencies');
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  &__header {
    padding-left: 15px;
  }

  &__label {
    padding: 0;
    text-align: left;
  }
}

.sender-label {
  width: 22%;
}

.beschreibung-label {
  width: 35%;
}

.medium-label {
  width: 14%;
  text-align: center;
}

.tools-label {
  width: 12%;
  text-align: center;
}

.dropdown-label {
  width: 3%;
}



.pendency--status--1::before {
  background-color: #ff3333;
}

.pendency--status--2::before {
  background-color: #FF9E0F;
}

.pendency--status--3::before {
  background-color: #22db8e;
}
</style>
